import { Box } from '@mui/material'
import MarkdownToJsx from 'markdown-to-jsx'

// Renders mentor/AI text written in Markdown as formatted, MUI-styled content.
// Raw HTML parsing is disabled, so it's safe to show author-written markdown to
// students (bold, italics, lists, headings, links, quotes, inline code).
export default function Markdown({ children, sx }: { children: string; sx?: object }) {
  return (
    <Box
      sx={{
        fontSize: '0.875rem',
        lineHeight: 1.6,
        '& > :first-of-type': { mt: 0 },
        '& > :last-child': { mb: 0 },
        '& p': { m: 0, mb: 1 },
        '& ul, & ol': { m: 0, mb: 1, pl: 3 },
        '& li': { mb: 0.25 },
        '& h1, & h2, & h3, & h4': { fontWeight: 700, fontSize: '0.95rem', m: 0, mt: 1.25, mb: 0.5 },
        '& blockquote': { m: 0, mb: 1, pl: 1.5, borderLeft: '3px solid', borderColor: 'divider', color: 'text.secondary' },
        '& code': { fontFamily: 'monospace', fontSize: '0.85em', bgcolor: 'action.hover', px: 0.5, py: 0.1, borderRadius: 0.5 },
        '& a': { color: 'primary.main' },
        '& strong': { fontWeight: 700 },
        ...sx,
      }}
    >
      <MarkdownToJsx options={{ forceBlock: true, disableParsingRawHTML: true }}>
        {children}
      </MarkdownToJsx>
    </Box>
  )
}
